/*
* Copyright (c) 2023 Eugenio Espinoza
*/

import React from 'react';
import './ShopGlance.css';

const CAMPAIGN = {
  src: 'https://us.masteredtrax.shop/cdn/shop/products/14-mujer-lentes-espalda2version_8e90ab02-4df9-4403-85bf-3de499b7e2ba_1080x.jpg?v=1609230631',
  srcFallback: 'https://us.masteredtrax.shop/cdn/shop/products/14-mujer-lentes-espalda2version_8e90ab02-4df9-4403-85bf-3de499b7e2ba_360x.jpg?v=1609230631',
  alt: 'Campaign — Mastered Trax capsule',
  label: 'The Campaign',
  caption: 'Capsule N° 01 · MMXXVI',
};

const OBJECTS = [
  {
    src: 'https://us.masteredtrax.shop/cdn/shop/products/gorra-hueso-blanca_1080x1080.jpg?v=1670621075',
    srcFallback: 'https://us.masteredtrax.shop/cdn/shop/products/gorra-hueso-blanca_360x.jpg?v=1670621075',
    alt: 'Mastered Trax bone-white cap',
    label: 'The Object',
    name: 'Gorra Hueso',
    type: 'Accessories · Embroidered cap',
  },
  {
    src: 'https://us.masteredtrax.shop/cdn/shop/products/0-playera-nino_1080x.jpg?v=1607804730',
    srcFallback: 'https://us.masteredtrax.shop/cdn/shop/products/0-playera-nino_360x.jpg?v=1607804730',
    alt: 'Mastered Trax kids tee',
    label: 'The Object',
    name: 'Playera Niño',
    type: 'Apparel · Kids collection',
  },
];

function ShopGlance() {
  return (
    <section className="mt-shop">
      <div className="mt-shop__topline mt-container">
        <div>
          <span className="mt-eyebrow">The Collection · AW26</span>
          <h2 className="mt-shop__title">
            Objetos de la casa.
            <em>Hechos con cuidado.</em>
          </h2>
        </div>
        <p className="mt-shop__intro">
          Una edición curada de piezas diseñadas en sociedad con nuestros
          artistas — grabadas, bordadas, prensadas. Envíos a todo el mundo
          desde nuestra tienda oficial.
        </p>
      </div>

      <div className="mt-shop__editorial mt-container">
        <a
          className="mt-shop__campaign"
          href="https://masteredtrax.shop"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Visit the Mastered Trax shop campaign"
        >
          <div className="mt-shop__campaignFrame">
            <img
              src={CAMPAIGN.src}
              onError={(e) => { e.currentTarget.src = CAMPAIGN.srcFallback; }}
              alt={CAMPAIGN.alt}
              loading="lazy"
            />
            <div className="mt-shop__overlay" aria-hidden="true" />
            <span className="mt-shop__tag">
              <span>Visit the store</span>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </span>
          </div>
          <div className="mt-shop__meta">
            <span className="mt-kicker">{CAMPAIGN.label}</span>
            <span className="mt-shop__caption">{CAMPAIGN.caption}</span>
          </div>
        </a>

        <div className="mt-shop__aside">
          {OBJECTS.map((o) => (
            <a
              key={o.name}
              className="mt-shop__object"
              href="https://masteredtrax.shop"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Shop ${o.name}`}
            >
              <div className="mt-shop__objectFrame">
                <img
                  src={o.src}
                  onError={(e) => { e.currentTarget.src = o.srcFallback; }}
                  alt={o.alt}
                  loading="lazy"
                />
                <span className="mt-shop__tag mt-shop__tag--light">
                  <span>Visit the store</span>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
              </div>
              <div className="mt-shop__meta">
                <span className="mt-kicker">{o.label}</span>
                <h3>{o.name}</h3>
                <p>{o.type}</p>
              </div>
            </a>
          ))}
        </div>
      </div>

      <div className="mt-shop__footer mt-container">
        <span className="mt-shop__note">Envíos nacionales e internacionales · masteredtrax.shop</span>
        <a
          className="mt-btn mt-btn--ghost mt-shop__all"
          href="https://masteredtrax.shop"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>Visit the store</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </a>
      </div>
    </section>
  );
}

export default ShopGlance;
